import { InfraredFlight } from "@nova/protobuf"
import { getColoredFilteredHotspotsByFlightId } from "@nova/util-hotspot"
import {
    getFlightpathKMLFromImages,
    getOrthoArcKml,
    getOrthoArcTargetUrl,
    getOrthoTakTiffKey,
    getOrthoTileUrl,
} from "./util"
import { ProjectWithMetadata } from "@nova/constants"
import {
    createHotspotsKML,
    hotspotsToIntterraKML,
    hotspotsToTAKKML,
    TAKHotspotOptions,
} from "@nova/data-create-hotspots-kml"
import { finished, infraredImagePath, outputFolder } from "@nova/util-s3"

export const infraredFlightTransformer = (flight: InfraredFlight, project: ProjectWithMetadata) => {
    const infraredFlightToKML = () => {
        const filteredHotspots = getColoredFilteredHotspotsByFlightId(flight.id, project)

        return createHotspotsKML(filteredHotspots, {
            relativeSizeEnabled: !!flight.relativeSizeEnabled,
        })
    }

    return {
        hotspotsKML: infraredFlightToKML,
        intterraKML: () =>
            hotspotsToIntterraKML(getColoredFilteredHotspotsByFlightId(flight.id, project), {
                relativeSizeEnabled: flight.relativeSizeEnabled,
            }),
        takKML: (options: TAKHotspotOptions) =>
            hotspotsToTAKKML(getColoredFilteredHotspotsByFlightId(flight.id, project), options),

        flightPathKML: (showPlacemarks = false) =>
            getFlightpathKMLFromImages(flight, showPlacemarks),

        orthoArcTargetUrl: () => getOrthoArcTargetUrl(flight, project),
        orthoArcKml: (resourceUrl: string) => getOrthoArcKml(flight, resourceUrl),
        orthoTakTiffKey: () => getOrthoTakTiffKey(flight, project, "smallTiff"),
        orthoTiff: () =>
            finished(
                outputFolder(project.orgId, project.id, flight.id),
                "tif",
                false,
                flight.cogOrtho?.fileId
            ),
        orthoKmz: () => finished(outputFolder(project.orgId, project.id, flight.id), "kmz"),
        orthoLowResTiff: () =>
            finished(outputFolder(project.orgId, project.id, flight.id), "tif", true),

        tileUrl: (opacity = 1) => getOrthoTileUrl(flight, project, opacity),
        entity: flight,
        project,
        imagePath: (id: string) => infraredImagePath(project.orgId, project.id, flight.id, id),
    }
}
